<template>
  <div class="bookstore-detail">
    <div class="book-introduction">
      <div class="left-demo-card">
        <div class="left-demo-body">
          <div class="left-img-box flex-center">
            <img
              :src="coverFiles.length > 0 ? coverFiles[currImg].fullUrl : ''"
              alt=""
            />
          </div>
          <div class="left-small-img">
            <img
              v-for="(item, index) in coverFiles"
              :key="index + Math.random()"
              :src="item.fullUrl"
              :class="index == currImg ? 'demo-card-box-img-checked' : ''"
              @click="changeSrc(index)"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="right-info">
        <div class="title">
          <div class="book-label">
            {{ callDictionaries(goodsTypeList, goodsInfo.resourceType) }}
          </div>
          <span>{{ goodsInfo.goodsTitle }}</span>
        </div>
        <div class="book-intro" v-if="goodsInfo.authorRecommendation">
          <div
            class="defaultIntro"
            @mouseenter="enterShow"
            @mouseleave="leaveShow"
          >
            <span class="twointro"
              >{{ goodsInfo.authorRecommendation | ellipsis(120) }}
              <span
                class="font"
                v-if="goodsInfo.authorRecommendation.length > 120"
                >更多</span
              ></span
            >
            <div v-if="showMore" class="allIntro">
              <span>{{ goodsInfo.authorRecommendation }}</span>
            </div>
          </div>
        </div>
        <div class="label">
          <span v-for="(item, index) in keyword" :key="index">{{ item }}</span>
        </div>
        <div class="book-intro-info">
          <div>
            <span>教学属性：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.teachPropertyAllStr == null ||
              goodsInfo.teachPropertyAllStr == ""
                ? "-"
                : goodsInfo.teachPropertyAllStr
            }}</span>
          </div>
          <div>
            <span>学科：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.subjectName == null || goodsInfo.subjectName == ""
                ? "-"
                : goodsInfo.subjectName
            }}</span>
          </div>
          <div>
            <span>题目数量：</span>
            <span class="ellipsis-aRow">{{
              goodsInfo.questionCount == null || goodsInfo.questionCount == ""
                ? "-"
                : goodsInfo.questionCount
            }}</span>
          </div>
        </div>
        <div class="select_question">
          <div
            class="question_flex"
            v-for="(item, index) in paperTypeList"
            :key="index"
          >
            <img class="img" src="@/assets/images/tixing.png" />
            <div>
              {{ paperType[Number(item.questionType) - 1].name }}：{{
                item.questionNum
              }}
            </div>
          </div>
        </div>
        <div class="backgroundx"></div>
        <el-button
          type="primary"
          @click="questionx(1)"
          class="question_but but_color_fff"
          >自测模式</el-button
        >
        <el-button
          type="warning"
          @click="questionx(2)"
          class="question_but but_color_fff"
          >练习模式</el-button
        >
        <el-button
          type="primary"
          plain
          @click="questionx(3)"
          class="question_but but_color_b"
          >错题本</el-button
        >
      </div>
    </div>
    <div class="table_list">
      <div class="title">
        <div>自测历史</div>
        <div>自测次数：{{ total }}</div>
      </div>
      <div
        class="title1"
        v-for="(item, index) in tableData"
        :key="index"
        @click="testRecord(item)"
      >
        <div class="paperName_name" style="width: 33%">
          {{ item.paperName }}自测结果
        </div>
        <div style="width: 33%">
          <div class="usetime" v-if="item.useTime">
            用时：{{ getTime(item.useTime) }}
          </div>
          <div class="usetime" v-if="!item.useTime">未提交</div>
        </div>
        <div>
          答对 {{ item.answerYesCount }} 答错 {{ item.answerWrongCount }} 未判错
          {{ item.answerNotJudgedCount }}
        </div>
      </div>

      <div class="pagination-box" v-if="total > 0">
        <el-pagination
          class="ou-pagination"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="queryParams.pageSize"
          layout="total, prev, pager, next, sizes, jumper, slot"
          :total="total"
        >
          <el-button class="ou-page-go">GO</el-button>
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog_flex">
        <div>
          <el-button type="primary" class="question_but" @click="practice(0)"
            >顺序练习</el-button
          >
        </div>
        <div style="margin-top: 20px">
          <el-button type="warning" class="question_but" @click="practice(1)"
            >乱序练习</el-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogVisible1"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog_flex">
        <div>
          <el-button type="primary" class="question_but" @click="jxAnswer(1)"
            >继续答题</el-button
          >
        </div>
        <div style="margin-top: 20px">
          <el-button type="warning" class="question_but" @click="jxAnswer(2)"
            >创建新练习</el-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialogVisible2"
      width="30%"
      :before-close="handleClose"
    >
      <div class="dialog_flex">
        <div>
          <el-button
            type="primary"
            class="question_but"
            @click="exercise('paginated')"
            >单题练习</el-button
          >
        </div>
        <div style="margin-top: 20px">
          <el-button
            type="warning"
            class="question_but"
            @click="exercise('scrolled')"
            >多题练习</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  goodsInfoDetail,
  checkIsBuy,
  teachingAttrList,
  isHavingPermissions,
} from "@/api/bookstore/bookstore";
import {
  getAnswerPaperRecord,
  selQuestionTypeAndNumBySubject,
  addPaperApi,
  getUnSubmitPaperRecord,
} from "@/api/answer/answer";
import { paperGetToken, getPaperIdApi, updatePaperId } from "@/api/index/index";
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      subjectId: "",
      difen: "",
      showMore: false,
      sourceList: "",
      keyword: [],
      goodsId: null,
      goodsType: null,
      goodsInfo: {}, //商品基本信息
      currImg: 0,
      coverFiles: [], //左侧商品图片数组
      authorList: [], //作者简介
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        answerPlatform: "out",
        paperGenerateMethod: "Zcms",
        paperId: "",
        userId: "",
        token: "",
        params1: "",
      },
      total: 0,
      goodsTypeList: [],
      tableData: [],
      paperTypeList: [],
      paperType: [],
      previewMode: "",
    };
  },
  computed: {},
  components: {},
  created() {
    this.$store.commit("subjectId_book", this.$route.query.goodsId);
    this.goodsId = this.$route.query.goodsId;
    this.goodsType = this.$route.query.goodsType;
    this.queryParams.userId = this.$store.state.user.userId;
    this.paperType = this.$store.getters.paperType;
    this.getList();
    this.getoc_resource_file();
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.goodsId) {
        this.$store.commit("subjectId_book", this.$route.query.goodsId);
        this.goodsId = this.$route.query.goodsId;
        this.goodsType = this.$route.query.goodsType;
        this.getList();
      }
    },
  },
  methods: {
    exercise(e) {
      this.dialogVisible2 = false;
      // e paginated单题模式 scrolled 多题模式
      this.previewMode = e;
      //questionxType 1自测 2练习 3错题本
      this.question(this.questionxType, e);
    },
    questionx(e) {
      if (e == 3) {
        this.question(e);
        return;
      }
      //questionxType 1自测 2练习 3错题本
      this.questionxType = e;
      this.dialogVisible2 = true;
    },
    jxAnswer(e) {
      // 1继续答题 2创建新练习
      if (e == 1) {
        this.continueAnsweringQuestions();
        this.dialogVisible1 = false;
      } else {
        this.dialogVisible1 = false;
        this.dialogVisible = true;
      }
    },
    testRecord(item) {
      console.log(item);
      this.$router.push({
        path: "/bookstore/answerRecord",
        query: {
          paperId: item.paperId,
          ansRecordId: item.id,
          goodsId: this.$route.query.goodsId,
          bookName: this.$route.query.bookName,
        },
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisible1 = false;
      this.dialogVisible2 = false;
    },
    // 开始练习
    startPracticing() {
      paperGetToken().then((token) => {
        getUnSubmitPaperRecord({
          answerPlatform: "out",
          paperId: "",
          userId: this.$store.getters.userId,
          params1: this.goodsId,
          token: token.data,
        }).then((res) => {
          if (res.code == 200) {
            //有练习记录
            this.dialogVisible1 = true;
          } else if (res.code == 205) {
            this.dialogVisible = true;
          }
        });
      });
    },
    // 继续答题
    continueAnsweringQuestions() {
      let routeUrl = this.$router.resolve({
        path: "/bookstore/paperAnswer",
        query: {
          answerType: "practice",
          goodsId: this.goodsId,
          typeOk: false,
          bookName: this.$route.query.bookName,
          previewMode: this.previewMode,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    //练习  创建试卷
    practice(type) {
      // type 0顺序 1乱序
      this.dialogVisible1 = false;
      this.dialogVisible = false;
      getPaperIdApi().then((paperId) => {
        let data = {
          subjectId: this.subjectId,
          testDuration: "",
          questionNum: this.goodsInfo.questionCount,
          paperGenerateMethod: "lxms",
          createUserId: this.$store.getters.userId,
          testPaperModuleList: [],
          stemSort: type,
          optionSort: type,
          id: paperId.data,
          fullMark: 0,
          passMark: 0,
        };
        console.log("paperId", paperId);
        paperGetToken().then((token) => {
          data.token = token.data;
          addPaperApi(data).then((res) => {
            updatePaperId({ paperId: res.id, goodsId: this.goodsId });
            let routeUrl = this.$router.resolve({
              path: "/bookstore/paperAnswer",
              query: {
                paperId: res.id,
                answerType: "practice",
                goodsId: this.goodsId,
                typeOk: false,
                bookName: this.$route.query.bookName,
                previewMode: this.previewMode,
              },
            });
            window.open(routeUrl.href, "_blank");
          });
        });
      });
    },
    //自测
    question(e, previewMode) {
      //questionxType 1自测 2练习 3错题本
      // paginated单题模式 scrolled 多题模式
      if (e == 1) {
        this.$router.push({
          path: "/bookstore/preview",
          query: {
            subjectId: this.subjectId,
            questionCount: this.goodsInfo.questionCount,
            filesId: this.filesId,
            goodsId: this.$route.query.goodsId,
            bookName: this.$route.query.bookName,
            previewMode: previewMode,
          },
        });
      } else if (e == 2) {
        //判断有无答题记录
        this.startPracticing();
      } else if (e == 3) {
        this.$router.push({
          path: "/user/errorBookV2/errDetail",
          query: {
            title: this.goodsInfo.goodsTitle,
            coverFileUrl: this.coverFiles[0].fullUrl,
            goodId: this.$route.query.goodsId,
            bookName: this.$route.query.bookName,
          },
        });
      }
    },
    enterShow() {
      if (this.goodsInfo.authorRecommendation.length > 135) {
        this.showMore = true;
      }
    },
    leaveShow() {
      this.showMore = false;
    },
    getList() {
      //商品基本信息
      goodsInfoDetail(this.goodsId).then((res) => {
        if (res.code == 200) {
          this.goodsInfo = res.data.goods;
          this.subjectId = this.goodsInfo.subjectId;
          this.sourceList = res.data.sourceList[0];
          if (this.goodsInfo.keyword) {
            this.keyword = this.goodsInfo.keyword.split(",");
          }
          this.coverFiles = res.data.coverFiles;
          if (this.coverFiles.length == 0) {
            let data = {
              fullUrl: require("@/assets/images/default_img.jpg"),
            };
            this.coverFiles.push(data);
          }
          this.authorList = res.data.authorList;
          this.getAnswerPaperRecord();
          this.getQuestionNumber();
        }
      });
    },

    //获取统计的答卷信息
    getAnswerPaperRecord() {
      paperGetToken().then((res) => {
        this.queryParams.token = res.data;
        this.queryParams.params1 = this.goodsId;
        getAnswerPaperRecord(this.queryParams).then((res) => {
          if (res.code == 200) {
            this.tableData = res.rows;
            this.total = res.total;
          }
        });
      });
    },
    // 根据学科查询题型及题型数量
    getQuestionNumber() {
      paperGetToken().then((token) => {
        selQuestionTypeAndNumBySubject(
          {
            subjectId: this.subjectId,
          },
          token.data
        ).then((res) => {
          this.paperTypeList = res.data || [];
        });
      });
    },

    changeSrc(index) {
      this.currImg = index;
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getAnswerPaperRecord();
    },
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getAnswerPaperRecord();
    },
    getoc_resource_file() {
      //来源
      teachingAttrList("oc_resource_file").then((res) => {
        this.goodsTypeList = res.data;
      });
    },
    // 格式化时间
    getTime(time) {
      if (time) {
        let m = parseInt(time / 60);
        let s = time % 60;
        let date = (m > 9 ? m : "0" + m) + "分" + (s > 9 ? s : "0" + s) + "秒";
        return date;
      } else {
        return "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.usetime {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.bookstore-detail {
  height: auto;
  padding-bottom: 40px;
  .book-introduction {
    display: flex;
    width: 1400px;
    min-height: 452px;
    background: #fffefd;
    margin: 0 auto 16px;
    box-sizing: border-box;
    padding: 20px 25px;
    .left-demo-card {
      margin-right: 67px;
      width: 380px;
      .left-demo-body {
        width: 380px;
        height: 380px;
        background: #fff;
        border: 1px solid #f2f2f2;
        .left-img-box {
          width: 280px;
          height: 280px;
          background: #fbfbfb;
          margin: 5px auto 15px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .left-small-img {
          display: grid;
          grid-column-gap: 5px;
          grid-template-columns: repeat(5, calc(20% - 4px));
          box-sizing: border-box;
          padding: 0 12px;
          img {
            width: 61px;
            height: 61px;
            object-fit: scale-down;
            background: #fbfbfb;
          }
          .demo-card-box-img-checked {
            border: 1px solid #1890ff;
          }
        }
      }
      .left-demo-bottom {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
          cursor: pointer;
          img {
            margin-right: 5px;
          }
          display: flex;
          align-items: center;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .right-info {
      width: 900px;
      .title_info {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        padding-bottom: 20px;
      }
      .title {
        display: flex;
        align-items: center;
        margin-bottom: 15px;
        .book-label {
          padding: 0 5px;
          height: 24px;
          background: #f9fdff;
          margin-right: 7px;
          border: 1px solid #0081ce;
          border-radius: 6px;
          font-size: 13px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #0081ce;
          line-height: 24px;
          text-align: center;
        }
        span {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: black;
          font-weight: bold;
        }
      }
      .book-intro {
        line-height: 20px;
        margin-bottom: 12px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #666666;
        .defaultIntro {
          position: relative;
          padding: 10px;
          box-sizing: border-box;
        }
        .allIntro {
          position: absolute;
          left: 0;
          top: 0;
          background: #fffefd;
          z-index: 999;
          box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          padding: 10px;
          box-sizing: border-box;
        }
        .font {
          color: #2e9adb;
          text-decoration: underline;
          cursor: pointer;
        }
      }
      .label {
        display: flex;
        align-items: center;
        margin-bottom: 25px;
        flex-wrap: wrap;
        span {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          background: #f2f2f2;
          border-radius: 6px;
          padding: 7px 10px;
          margin-right: 16px;
          box-sizing: border-box;
          display: block;
          margin-bottom: 8px;
        }
        span:last-child {
          margin-right: 0;
        }
      }
      .book-intro-info {
        width: 850px;
        display: flex;
        align-items: center;
        margin-bottom: 15px;

        > div {
          flex: 1;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          align-items: center;
        }
        > div:nth-of-type(1) {
          span:last-child {
            width: 200px;
          }
        }
        > div:nth-of-type(2) {
          span:last-child {
            width: 200px;
          }
        }
        > div:nth-of-type(3) {
          span:last-child {
            width: 200px;
          }
        }
      }
      .buttons {
        margin-top: 30px;
      }
    }
  }
}
.table_list {
  width: 1400px;
  margin: 16px auto 40px auto;
  background: #fffefd;
  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 29px 56px;
    border: #f2f2f2 solid 1px;
  }
  .title1 {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-family: PingFang SC;
    padding: 20px;
    color: #666666;
  }
}
.pagination-box {
  text-align: right;
  background: #fffefd;
  padding: 25px 0;
}
.underline {
  // font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  text-decoration: underline;
  color: #2e9adb;
  line-height: 17px;
  cursor: pointer;
}
.backgroundx {
  width: 899px;
  height: 2px;
  background: #f2f2f2;
  margin: 15px 0;
}
.select_question {
  width: 800px;
  background: #e5f5ff;
  border-radius: 6px;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  flex-wrap: wrap;
  padding: 10px;
  .question_flex {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 9px;
    width: 30%;
    padding: 5px;
    .img {
      width: 14px;
      height: 14px;
    }
  }
}
.question_but {
  width: 202px;
  height: 40px;
}
.but_color_fff {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.but_color_b {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #2e9adb;
}
.dialog_flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 200px;
  margin: 0 auto;
}
.paperName_name {
  cursor: pointer;
  color: #2e9adb;
}
</style>
